export default {
  avgPrice: {
    id: 'landing_price_filter_avg',
    defaultMessage: 'The average price is {amount, number, currency}',
  },
}
